import { Types } from "../../constants/index.js";
import SubField from "../builders/SubField.js";
export default SubField({
  objectType: Types.firmwareRelease,
  baseAttrName: 'upgradeOptions',
  baseAttrField: 'upgradeOptions',
  field: 'loadBalancerEnabled',
  creatable: true,
  editable: false,
  createOptions: {
    containerProps: {
      fillCell: true
    }
  },
  displayName: 'Load Balancer Enabled',
  valueType: 'boolean',
  getDefaultValue: () => true
});